
export interface FileExport {
    EmailDownloadValue: number,
    email: string,
    excelFormat: string
}


export class ExcelColumns {
    placardId: string;
    status: string;
    pickupStartDate: string;
    companyName: string;
    address: string;
    clientKey: string;
}